import { useState, useEffect, memo, useRef } from 'react';
import { useAuth } from "../../context/loginContext.js";
import { Link, useNavigate } from "react-router-dom";
import axiosAWS from '../../api/configAxios.js';
import axiaxiosRobot from '../../api/configReCaptcha.js';
import ReCAPTCHA from "react-google-recaptcha";
import Cookie from "js-cookie";
import './login.css';
import Swal from 'sweetalert2';


const Login = () => {

    const { save_date_user, user_autenticado, setIp_public, ip_public } = useAuth();

    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [c_null, setC_null] = useState(false);
    const [p_null, setP_null] = useState(false);
    const [text_p, setText_p] = useState('');
    const [text_c, setText_c] = useState('');
    const [sw_ver, setSw_ver] = useState(false);
    const [button, setButton] = useState(true);
    const [robotCap, setRobotCap] = useState(false);
    const [LoadrobotCap, setLoadRobotCap] = useState(false);
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const [PassVwE, setPassVwE] = useState(false);

    const abortControllerRef = useRef(new AbortController());

    const navigate = useNavigate();
    var validar = false;

    const recaptchaRef = useRef();

    const envio_form = async (e) => {
        e.preventDefault();

        if (user !== "") {
            validar = true;
            setC_null(false);
        } else {
            validar = false;
            setC_null(true);
            setText_c('campo requerido');
        }
        if (password !== "") {
            validar = true;
            setP_null(false);
        } else {
            validar = false;
            setP_null(true);
            setText_p("campo requerido")
        }

        if (validar) {
            setButton(false);
            try {
                const result_auth = await axiosAWS.post("login/create_session", { correo: user, stSecret: password, ipLocal: "1.1.1.1", ipPublic: ip_public }).catch(function (error) {
                    if (error.response.status === 400) {
                        //console.log("error 400");
                    }

                    if (error.response.status >= 500) {
                        //console.log("algo anda mal con la el servidor");
                    }
                });
                setButton(true);

                //console.log(result_auth);

                if (result_auth.data.hasOwnProperty("mensaje")) {
                    //console.log("Usuario Denegado");
                    alert("Usuario Denegado");
                    setButton(true);
                    return
                }

                if (result_auth.status >= 200 || result_auth.status <= 299) {
                    if (result_auth.data.data.hasOwnProperty("token")) {
                        if (result_auth.data.data.token !== null && result_auth.data.data.user.hasOwnProperty("correo")) {
                            const newLocal = 0.625;
                            Cookie.set('AutKeyPbi', result_auth.data.data.token, { expires: newLocal });
                            abortControllerRef.current.abort();

                            save_date_user(result_auth.data.data.user);
                            navigate("/home");
                        } else {
                            alert("Verifica tus credenciales");
                        }

                    }

                } else {
                    alert("usuario denegado");
                }


            } catch (error) {

                //console.log("error servidorAWS");
                alert("Error con el servicio");
                setButton(true);
                return
            }
        } else {
            //console.log("sin datos");
        }
    }

    const vw_passwordE = (e) => {
        if (!PassVwE) {
            //add = '<i class="bi bi-eye-slash-fill"></i>';
            setPassVwE(true);
            //document.getElementById("pass-intE").type = "text";
        } else {
            //add = '<i class="bi bi-eye-fill"></i>';
            setPassVwE(false);
            //document.getElementById("pass-intE").type = "password";
        }
    }

    const recaptcha_result = async (_data) => {

        if (LoadrobotCap) {
            return
        }

        console.log("ataque")
        setLoadRobotCap(true)
        const recaptchaValue = _data;
        console.log(recaptchaValue);

        try {

            const result_auth = await axiaxiosRobot.post("reCAPTCHA", { response: recaptchaValue }).catch(function (error) {
                if (error.response.status === 400) {
                    //console.log("error 400");
                }

                if (error.response.status >= 500) {
                    //console.log("algo anda mal con la el servidor");
                }
            });

            if (result_auth.data.result === "correcto") {
                setRobotCap(true);
                Swal.fire({
                    icon: 'info',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    title: 'Info',
                    text: '¡Adelante! Ya puedes continuar',
                    timer: 4000
                });
            } else {
                Swal.fire({
                    icon: 'info',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    title: 'Info',
                    text: 'El tiempo ha expirado. Por favor, inténtalo nuevamente.',
                    timer: 4000
                });

                setRobotCap(false);
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                title: 'Error',
                text: '¡Vaya! Parece que hubo un problema con la verificación. Inténtalo de nuevo en un momento.',
                timer: 4000
            });
            setRobotCap(false);
        }

        setLoadRobotCap(false)

    }

    window.onRecaptchaSuccess = async (response) => {
        await recaptcha_result(response);
    };

    //retornamos "la vista para el login";
    useEffect(() => {
        const cookie = Cookie.get();
        if (user_autenticado && cookie.AutKeyPbi) {
            //si esta ya se aplico el logue, entonces lo mandamos al "home"
            navigate("/home");
        }
    });

    useEffect(() => {
        const URL_API = "https://api.ipify.org/?format=json";
        fetch(URL_API)
            .then(respuestaRaw => respuestaRaw.json())
            .then(respuesta => {
                setIp_public(respuesta.ip);
                //console.log(respuesta.ip);
            });
    }, [ip_public]);

    /*
    useEffect(() => {
        // Cargar el script de reCAPTCHA

        if (!document.getElementById("g-recaptcha")) {

            if(document.getElementById("go-rob-chid")){
                document.getElementById("go-rob-chid").remove();
            }

            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js';
            script.async = true;
            script.defer = true;
            script.id = "go-rob-chid";
            document.body.appendChild(script);


            // Inyectar el div de reCAPTCHA
            const recaptchaContainer = document.getElementById('recaptcha-container');
            const siteKey = '6LdZVdQqAAAAAGek70QFrovIB6uTPig7xqGCpBlT'; // Reemplaza con tu clave

            recaptchaContainer.innerHTML = "";

            const recaptchaDiv = document.createElement('div');
            recaptchaDiv.className = 'g-recaptcha';
            recaptchaDiv.setAttribute('data-sitekey', siteKey);
            recaptchaDiv.setAttribute('data-callback', 'onRecaptchaSuccess');
            recaptchaContainer.appendChild(recaptchaDiv);

            // Renderizar reCAPTCHA
            if (window.grecaptcha) {
                window.grecaptcha.render(recaptchaDiv, {
                    'sitekey': siteKey,
                    'callback': window.onRecaptchaSuccess,
                });
            }

            // Limpiar el script al desmontar el componente
            
            return () => {
                document.body.removeChild(script);
            };
            

        }

    }, []);
    */

    return (

        <>
            <div className="py-5 bg-dark-subtle h-100 p-0">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col-12 col-md-8 col-lg-6 col-xl-5">
                        <form onSubmit={(e) => { envio_form(e) }} id='form_env'>
                            <div className="card shadow-2-strong" style={{ borderRadius: '1rem' }}>
                                <div className="card-body p-5 text-center">
                                    <h3 className="mb-5">Iniciar Sesión</h3>
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="floatingInput" value={user} onChange={(e) => { setUser(e.target.value); setC_null(false) }} placeholder="HRNI456SDF" required />
                                        <label htmlFor="floatingInput">Usuario</label>
                                    </div>

                                    <div className="input-group mb-3">
                                        <div className="form-floating">
                                            {
                                                PassVwE ?
                                                    <input type="text" className="form-control" id="pass-encript" value={password} onChange={(e) => { setPassword(e.target.value); setP_null(false) }} placeholder="******" required />
                                                    :
                                                    <input type="password" className="form-control" id="pass-encript" value={password} onChange={(e) => { setPassword(e.target.value); setP_null(false) }} placeholder="******" required />
                                            }

                                            <label htmlFor="pass-encript">Contraseña</label>
                                        </div>

                                        <button className="btn btn-outline-secondary" type="button" id="button-addon2" title='ver contraseña' onClick={(e) => { vw_passwordE(e) }}>
                                            {
                                                PassVwE ?
                                                    <i className="bi bi-eye-fill"></i>
                                                    :
                                                    <i className="bi bi-eye-slash-fill"></i>

                                            }

                                        </button>
                                    </div>

                                    <div className='col-12 mb-3 d-flex justify-content-center align-items-center' id='recaptcha-container'>

                                        <ReCAPTCHA
                                            ref={recaptchaRef}
                                            sitekey="6LdZVdQqAAAAAGek70QFrovIB6uTPig7xqGCpBlT"
                                            onChange={recaptcha_result}
                                        />



                                    </div>
                                    {/** <p className="small mb-5 pb-lg-2"><a className="text-muted" href="#!">Olvidaste tu contraseña</a></p> */}
                                    <p className="small mb-5 mt-2 pb-lg-2"><label className="text-muted">En caso de haber olvidado su contraseña, le solicitamos contactar directamente al área de BI.</label></p>

                                    {
                                        robotCap ?
                                            <button className="btn btn-primary btn-lg btn-block" disabled={!button}>
                                                {
                                                    button === true ?
                                                        <>
                                                            {/**<button className="alargar" type="submit">Ingresar</button> */}

                                                            Ingresar
                                                        </>

                                                        :
                                                        <>Validando...</>
                                                }

                                            </button>
                                            :

                                            <>
                                                {
                                                    LoadrobotCap ?

                                                        <div className="alert alert-warning" role="alert">
                                                            Verificando...
                                                        </div>


                                                        :

                                                        <div className="alert alert-info" role="alert">
                                                            Debes verificar que no eres un robot antes de continuar.
                                                        </div>
                                                }
                                            </>
                                    }

                                </div>
                                <p className="small ms-2 mb-0"><label className="text-muted">V1.11.24.s2i1</label></p>
                                {/**cambio de server, agregado de cambios en el interface */}
                            </div>
                        </form>
                        
                    </div>
                </div>
            </div>
        </>
    );


}

export default memo(Login);
